import Modal from '@/components/atoms/Modal'
import { modalCreators } from '@/store/ducks/modal'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import LocalStorage from '@/utils/helpers/LocalStorage'

interface StatusModalProps {
	disabledOnClose?: boolean
}

export function Wellness({ disabledOnClose }: StatusModalProps) {
	const {
		modal: { modalInfo },
	} = useAppSelector((state) => state)

	const dispatch = useAppDispatch()
	const storage = new LocalStorage()

	const handleClose = () => {
		storage.set('viewedPopupWellness', true)
		dispatch(modalCreators.closeModal())
	}

	return (
		<Modal
			name='wellnessModal'
			disabledOnClose={disabledOnClose}
			onClose={handleClose}
			className='p-0 rounded-2xl md:px-0 md:pt-0 md:pb-0 md:rounded-[32px] dark:bg-zinc-950 max-w-[1071px]'
		>
			<div className='relative w-full aspect-[10/16] md:aspect-[1071/572] min-h-[280px] md:min-h-[400px] overflow-hidden md:rounded-[32px]'>
				<picture>
					<source
						media='(min-width: 768px)'
						srcSet='/imgs/admin/modals/bg-wellness.webp'
					/>

					<img
						src='/imgs/admin/modals/bg-wellness-mobile.webp'
						alt='Imagem do card de wellness'
						onClick={() => {
							window.open(modalInfo?.wellness_url)
							handleClose()
						}}
						className='absolute inset-0 h-full w-full cursor-pointer object-fill'
					/>
				</picture>
			</div>
		</Modal>
	)
}